/* ===== Way Out West Sportfishing — theme.js ===== */
(function(){
  'use strict';
  const $=(s,r)=>(r||document).querySelector(s);
  const $$=(s,r)=>[...(r||document).querySelectorAll(s)];
  const money=c=>{
    const f=(window.WOW_MONEY_FORMAT||'${{amount}}');
    const v=(c/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
    return f.replace(/\{\{\s*amount\s*\}\}/,v).replace(/\{\{\s*amount_no_decimals\s*\}\}/,Math.round(c/100));
  };

  /* ---------- Toast ---------- */
  let tt;
  function toast(msg){
    let t=$('#wow-toast');
    if(!t){t=document.createElement('div');t.id='wow-toast';t.className='toast';document.body.appendChild(t);}
    t.textContent=msg;t.classList.add('show');clearTimeout(tt);tt=setTimeout(()=>t.classList.remove('show'),2200);
  }
  window.wowToast=toast;

  /* ---------- Mobile menu ---------- */
  function initMobile(){
    const hb=$('#hamburger'),mm=$('#mobileMenu');
    if(!hb||!mm)return;
    hb.addEventListener('click',()=>{const o=mm.classList.toggle('open');hb.classList.toggle('on',o);document.body.style.overflow=o?'hidden':'';});
    $$('a',mm).forEach(a=>a.addEventListener('click',()=>{mm.classList.remove('open');hb.classList.remove('on');document.body.style.overflow='';}));
  }

  /* ---------- Cart drawer ---------- */
  const drawer=()=>$('#cartDrawer'), overlay=()=>$('#cartOverlay');
  function openCart(){const d=drawer(),o=overlay();if(d)d.classList.add('open');if(o)o.classList.add('open');}
  function closeCart(){const d=drawer(),o=overlay();if(d)d.classList.remove('open');if(o)o.classList.remove('open');}
  window.wowOpenCart=openCart;

  function renderCart(cart){
    const items=$('#cartItems'),count=$$('.cart-count'),sub=$('#cartSubtotal');
    const c=cart.item_count||0;
    count.forEach(el=>{el.textContent=c;el.style.display=c?'flex':'none';});
    if(!items)return;
    if(!cart.items||!cart.items.length){
      items.innerHTML='<div class="empty"><svg width="54" height="54" fill="none" stroke="currentColor" stroke-width="1.4" viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.7 13.4a2 2 0 0 0 2 1.6h9.7a2 2 0 0 0 2-1.6L23 6H6"/></svg><p>Your cart is empty.<br>Add some gear or book a trip.</p></div>';
    }else{
      items.innerHTML=cart.items.map(it=>{
        const img=it.image?`<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i,'_120x120$1$2')}" alt="">`:'';
        return `<div class="citem" data-key="${it.key}">
          <div class="th">${img}</div>
          <div class="ci-b"><b>${it.product_title}</b>
            ${it.variant_title&&it.variant_title!=='Default Title'?`<span class="meta">${it.variant_title}</span>`:''}
            <span class="p">${money(it.final_line_price)}</span>
            <div class="qty"><button data-act="dec" data-key="${it.key}">−</button><span>${it.quantity}</span><button data-act="inc" data-key="${it.key}">+</button></div>
            <button class="rm" data-act="rm" data-key="${it.key}">Remove</button>
          </div></div>`;
      }).join('');
    }
    if(sub)sub.textContent=money(cart.total_price||0);
  }

  function fetchCart(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json());}
  function refresh(){fetchCart().then(renderCart).catch(()=>{});}

  function changeLine(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:qty})})
      .then(r=>r.json()).then(renderCart).catch(()=>toast('Could not update cart'));
  }

  function addVariant(id,qty,btn){
    if(btn){btn.disabled=true;btn.dataset.label=btn.textContent;btn.textContent='Adding…';}
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(id),quantity:qty||1}]})})
      .then(r=>r.json().then(d=>({ok:r.ok,d})))
      .then(({ok,d})=>{
        if(!ok){toast(d&&d.description?d.description:'Could not add to cart');return;}
        toast('Added to cart');refresh();openCart();
      }).catch(()=>toast('Could not add to cart'))
      .finally(()=>{if(btn){btn.disabled=false;btn.textContent=btn.dataset.label||'Add';}});
  }

  function initCart(){
    const openBtns=$$('#openCart, .js-open-cart');
    openBtns.forEach(b=>b.addEventListener('click',e=>{e.preventDefault();openCart();}));
    const close=$('#closeCart');if(close)close.addEventListener('click',closeCart);
    const ov=overlay();if(ov)ov.addEventListener('click',closeCart);
    document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCart();});

    // delegated qty/remove inside drawer
    const items=$('#cartItems');
    if(items)items.addEventListener('click',e=>{
      const b=e.target.closest('[data-act]');if(!b)return;
      const key=b.dataset.key,line=b.closest('.citem');
      const cur=line?Number($('.qty span',line).textContent):1;
      if(b.dataset.act==='inc')changeLine(key,cur+1);
      else if(b.dataset.act==='dec')changeLine(key,Math.max(0,cur-1));
      else if(b.dataset.act==='rm')changeLine(key,0);
    });

    // delegated "add to cart" from product cards
    document.addEventListener('click',e=>{
      const b=e.target.closest('.js-add');if(!b)return;
      e.preventDefault();
      if(b.dataset.variant)addVariant(b.dataset.variant,1,b);
    });
    refresh();
  }

  /* ---------- Product page ---------- */
  function initProduct(){
    const root=$('#ProductForm');if(!root)return;
    let variants=[];
    try{variants=JSON.parse($('#ProductVariants').textContent);}catch(_){}
    const selects=$$('.js-option',root);
    const idField=$('#ProductVariantId',root);
    const priceEl=$('#ProductPrice');
    const addBtn=$('#ProductAdd',root);

    function current(){
      const chosen=selects.map(s=>s.value);
      return variants.find(v=>v.options.every((o,i)=>o===chosen[i]))||variants.find(v=>v.id==idField.value);
    }
    function update(){
      const v=current();
      if(!v)return;
      idField.value=v.id;
      if(priceEl){
        priceEl.innerHTML=(v.compare_at_price>v.price?`<s>${money(v.compare_at_price)}</s>`:'')+money(v.price);
      }
      if(addBtn){
        if(v.available){addBtn.disabled=false;addBtn.textContent='Add To Cart';}
        else{addBtn.disabled=true;addBtn.textContent='Sold Out';}
      }
    }
    selects.forEach(s=>s.addEventListener('change',update));
    update();

    // qty picker
    const qInput=$('#ProductQty',root);
    $$('.qty-pick button',root).forEach(b=>b.addEventListener('click',()=>{
      let v=Number(qInput.value)||1;v+=(b.dataset.dir==='up'?1:-1);qInput.value=Math.max(1,v);
    }));

    // gallery
    const main=$('#PMain'),thumbs=$$('.pthumbs img');
    thumbs.forEach(t=>t.addEventListener('click',()=>{
      if(main)main.src=t.dataset.full||t.src;
      thumbs.forEach(x=>x.classList.remove('sel'));t.classList.add('sel');
    }));

    // add to cart (AJAX) instead of full page redirect
    root.addEventListener('submit',e=>{
      e.preventDefault();
      addVariant(idField.value,Math.max(1,Number(qInput?qInput.value:1)),addBtn);
    });
  }

  /* ---------- Video play ---------- */
  function initVideos(){
    document.addEventListener('click',e=>{
      const ph=e.target.closest('.js-video');if(!ph)return;
      const id=ph.dataset.youtube;if(!id)return;
      ph.innerHTML=`<iframe src="https://www.youtube.com/embed/${id}?autoplay=1" title="video" allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture" allowfullscreen></iframe>`;
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    initMobile();initCart();initProduct();initVideos();
  });
})();
